export class MSignin {
  username:string
  password:string
  
  constructor() {
    this.username = ''
    this.password = ''
  }
}
